import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Loader from "react-loader-spinner";
import GenericCarousel from "../generic/GenericCarousel";

export const TabContainer = ({
  courseDescription,
  userCourses,
  relatedCourse,
  children,
  dir,
  history,
  courseId,
  hanldeCourseIdChange  
}) => {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
      {history.router.asPath.includes("coursedetail" && `${courseId}`) && (
        <React.Fragment>
          <h5 className="h5 semi-bold m-t-40 text-black">Related Courses</h5>
          <div className="m-b-100">
            <div
              style={{ position: "relative" }}
              id="carousel-content-fromCourseDescription"
              className=""
            >
              {courseDescription &&
              courseDescription.isSuccess &&
              relatedCourse.length ? (
                <GenericCarousel
                  dots={false}
                  marginLeft={10}
                  fromCourseDescription={true}
                  numberOfCards={3}
                >
                  {relatedCourse
                    .filter(
                      element =>
                      element.language_id && courseDescription.data.data.language_descriptions
                      .language_id && element.language_id !==
                        courseDescription.data.data.language_descriptions
                          .language_id
                    )
                    .map((element, index) => {
                      return (
                        <div key={index} className="">
                          <div
                            onClick={() => {
                              history.pushRoute(
                                `/coursedetail/programming/learn/${element.name.split(" ").join("-").replace("#", "")}/${element.language_id}`
                                );
                              hanldeCourseIdChange(element.language_id);
                            }}
                            style={{ cursor: "pointer" }}
                            className="card"
                          >
                            <div
                              className="course-img ph-blue"
                              style={{
                                backgroundImage: ` linear-gradient(29deg,${element.bottomcolor} , ${element.topcolor})`
                              }}
                            >
                              <img
                                src={element.icon}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            {element.tag && (
                              <div className="course-label">{element.tag}</div>
                            )}
                            <div className="subject">
                              <h5 className="h5 semi-bold text-light-grey">
                                {element.name}
                              </h5>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </GenericCarousel>
              ) : (
                <div
                  style={{
                    position: "relative",
                    marginTop: "100px",
                    left: "48%"
                  }}
                >
                  <Loader type="Oval" color="#915ce5" height={80} width={80} />
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired
};
